import apiClient from "./apiClient";
import { CreatePropertyRequest } from "../models/RequestModels/CreatePropertyRequest";
import { ApiCollectionResponse } from "../models/ResponseModels/ApiCollectionResponse";
import { ApiSingleResponse } from "../models/ResponseModels/ApiSingleResponse";
import { PropertyResponse } from "../models/ResponseModels/PropertyResponse";

export const getPropertiesRequest = async (): Promise<
  ApiCollectionResponse<PropertyResponse>
> => {
  const response =
    await apiClient.get<ApiCollectionResponse<PropertyResponse>>("/properties");
  return response.data;
};

export const getPropertyRequest = async (
  id: number,
): Promise<ApiSingleResponse<PropertyResponse>> => {
  const response = await apiClient.get<ApiSingleResponse<PropertyResponse>>(
    `/properties/${id}`,
  );
  return response.data;
};

export const createPropertyRequest = async (
  body: CreatePropertyRequest,
): Promise<ApiSingleResponse<PropertyResponse>> => {
  const response = await apiClient.post<ApiSingleResponse<PropertyResponse>>(
    "/properties",
    body,
  );
  return response.data;
};

export const updatePropertyRequest = async (
  id: number,
  body: Partial<CreatePropertyRequest>,
): Promise<ApiSingleResponse<PropertyResponse>> => {
  const response = await apiClient.patch<ApiSingleResponse<PropertyResponse>>(
    `/properties/${id}`,
    body,
  );

  return response.data;
};

export const deletePropertyRequest = async (id: number): Promise<void> => {
  await apiClient.delete(`/properties/${id}`);
};
